export enum ConsoleUserTypes {
  USER = 'User',
  LEASING_AGENT = 'Leasing Agent',
  ASSISTANT_PROPERTY_MANAGER = 'Assistant Property Manager',
  PROPERTY_MANAGER = 'Property Manager',
  MANAGER = 'Manager',
  ORGANIZATION_MANAGER = 'Organization Manager',
  MODERATOR = 'Moderator',
}
